module.exports = __webpack_public_path__ + "static/media/usbsubject.89081a94.jpg";